import { ShowSection } from 'framework/ui/layout';
import Risks from './Risks';
import { FormShowTemplate } from 'framework/form';
import useRiskService from './useRiskService';
import { EditableListFormShowTemplate, NEW_ROW_ID_PREFIX } from 'framework/list';
import { getRisksInitialData } from './utils';
import { RISK_STATUS, ProjectRisksResponse, RisksType, useProjectDataContext } from 'domain/shared/newProject';

const RisksContext = ({ data }: { data?: ProjectRisksResponse }) => {
  const { risksBatch, getRisksValidationSchema } = useRiskService();
  const { data: projectData } = useProjectDataContext();

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <FormShowTemplate
        isInitialsLoadingPosition
        initialData={getRisksInitialData(data?.baseProject)}
        submitFormFunc={values =>
          risksBatch(
            projectData.id,
            values.result.map(({ technicalNote, mitigationStrategyStatus, ...props }: RisksType) => {
              const existingTimeline = Array.isArray(props.timeline) ? props.timeline : [];
              return {
                ...props,
                ...(props.id.toString().startsWith(NEW_ROW_ID_PREFIX) && {
                  id: null,
                  alias: null,
                  status: RISK_STATUS.ACTIVE,
                }),
                timeline: technicalNote ? [...existingTimeline, { text: technicalNote }] : existingTimeline,
              };
            }),
          ).then(response => ({ result: response }))
        }
        afterSubmit={{
          message: 'You are awesome! The Risks have been successfully updated.',
        }}
        getValidationSchemaFunc={getRisksValidationSchema}
      >
        <EditableListFormShowTemplate listSource="risks" localStorageKey={`project:${data?.baseProject.id}:risks`}>
          <Risks />
        </EditableListFormShowTemplate>
      </FormShowTemplate>
    </ShowSection>
  );
};

export default RisksContext;
